export default __webpack_public_path__ + "static/media/Mercenary's Vambraces of the Roaring Jungle.98735202.jpg";